import { Spinner } from "@heroui/react";

function LoaderOverlay({
    children,
    isLoading,
}: {
    children: React.ReactNode;
    isLoading: boolean;
}) {
    return (
        <div className="relative">
            {children}
            {isLoading && (
                <div className="absolute inset-0 z-10 flex items-center justify-center rounded-lg bg-background/50 backdrop-blur-[1px]">
                    <Spinner size="sm" color="secondary" />
                </div>
            )}
        </div>
    );
}

export default LoaderOverlay;
